module.exports = __webpack_public_path__ + "themes/non-default/vennProvidedLogo.905e4175abf458eef66059fe19f9a6ee.png";